'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SeedId$() {
  this.caq = null;
  this.car = false;
}
export { $c_Lpresto_types$SeedId$ as $c_Lpresto_types$SeedId$ };
$p = $c_Lpresto_types$SeedId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SeedId$;
/** @constructor */
function $h_Lpresto_types$SeedId$() {
}
export { $h_Lpresto_types$SeedId$ as $h_Lpresto_types$SeedId$ };
$h_Lpresto_types$SeedId$.prototype = $p;
$p.crF = (function() {
  if ((!this.car)) {
    this.caq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.car = true;
  }
  return this.caq;
});
var $d_Lpresto_types$SeedId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SeedId$, "presto.types$SeedId$", ({
  a1Q: 1,
  D: 1
}));
export { $d_Lpresto_types$SeedId$ as $d_Lpresto_types$SeedId$ };
var $n_Lpresto_types$SeedId$;
function $m_Lpresto_types$SeedId$() {
  if ((!$n_Lpresto_types$SeedId$)) {
    $n_Lpresto_types$SeedId$ = new $c_Lpresto_types$SeedId$();
  }
  return $n_Lpresto_types$SeedId$;
}
export { $m_Lpresto_types$SeedId$ as $m_Lpresto_types$SeedId$ };
//# sourceMappingURL=presto.types$-Seed-Id$.js.map
